document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const updateCount = async () => {
    try {
      const response = await fetch(`${routes.cart_url}.js`);
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach(count => { count.textContent = cart.item_count; });
    } catch (error) { console.error(error); }
  };
  subscribe(PUB_SUB_EVENTS.cartUpdate, updateCount);
  document.addEventListener('click', event => {
    const link = event.target.closest('a.cart-icon, #cart-icon-bubble');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.open(link);
  }, true);
  document.querySelectorAll('a.cart-icon').forEach(link => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'CartDrawer');
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.closest('product-form')) return;
    if (!/\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action).pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.adding === 'true') return;
    form.dataset.adding = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-cart-error]') || document.createElement('p');
    error.dataset.cartError = '';
    error.setAttribute('role', 'alert');
    error.textContent = '';
    if (!error.isConnected) form.append(error);
    const data = new FormData(form);
    data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.set('sections_url', window.location.pathname);
    drawer.setActiveElement(document.querySelector('a.cart-icon, #cart-icon-bubble') || button);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || window.cartStrings.error);
      form.closest('dialog')?.close();
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'theniya-cart', cartData: result });
    } catch (failure) {
      error.textContent = failure.message || window.cartStrings.error;
    } finally {
      delete form.dataset.adding;
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }, true);
});
